var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9_3538",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 17
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9_3538)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 12.5002C5.63333 12.5002 5.31944 12.3696 5.05833 12.1085C4.79722 11.8474 4.66667 11.5335 4.66667 11.1668V3.16683C4.66667 2.80016 4.79722 2.48627 5.05833 2.22516C5.31944 1.96405 5.63333 1.8335 6 1.8335H12C12.3667 1.8335 12.6806 1.96405 12.9417 2.22516C13.2028 2.48627 13.3333 2.80016 13.3333 3.16683V11.1668C13.3333 11.5335 13.2028 11.8474 12.9417 12.1085C12.6806 12.3696 12.3667 12.5002 12 12.5002H6ZM6 11.1668H12V3.16683H6V11.1668ZM3.33333 15.1668C2.96667 15.1668 2.65278 15.0363 2.39167 14.7752C2.13056 14.5141 2 14.2002 2 13.8335V4.50016H3.33333V13.8335H10.6667V15.1668H3.33333Z",
    fill: "#0A100D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.20494646d56844991ef5f28f280420bf.svg";
export { ForwardRef as ReactComponent };